module.exports = __webpack_public_path__ + "static/webhook-26fb1c2e347b7a55cefe4b4271d3f348.png";